export default "__VITE_ASSET__B0ArfL0k__"